'use client';

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import CWSongCoversSection from '@/context/global/components/g02/g02-d01/g02-d01-g004-cw-song-covers-section';
import Header from '@/context/global/components/Layout/Header';
import Footer from '@/context/global/components/Layout/Footer';
import IconSearchNotFound from '@/context/global/components/Icon/IconSearchNotFound';
import { usePlayList } from '@/context/global/hooks/usePlaylist';
import { TPlayList } from '@/context/global/types/playlist';
import { TSong } from '@/context/global/types/song';
import SongModalProvider from '@/context/global/providers/SongModalProvider';
import { useKaraokeStore } from '@/context/global/stores/karaokeStore';

export default function G02D04PlaylistPage() {
  const t = useTranslations();
  const router = useRouter();
  const { fetchPlayList, loading, error } = usePlayList();
  const [playlist, setPlaylist] = useState<TPlayList | null>(null);
  const { setSelectedSong } = useKaraokeStore();
  useEffect(() => {
    const loadPlayLisy = async () => {
      const data = await fetchPlayList();

      if (data) {
        setPlaylist(data);
      }
    };
    loadPlayLisy();
  }, []);

  const handleBack = () => {
    router.back();
  };

  const handledClickViewAll = (playlistId: number) => {
    router.push(`/playlist-detail/${playlistId}`);
  };

  const handleSongClick = (song: TSong) => {
    setSelectedSong(song);
  };

  const hasData = !!playlist;
  const notFound = !loading && !error && !hasData;
  return (
    <div className="bg-background flex min-h-screen flex-col overflow-x-hidden">
      <Header />
      <SongModalProvider>
        {loading && (
        <div className="mt-20 flex h-full flex-col items-center justify-center py-20 text-center">
          <div className="h-16 w-16 animate-spin rounded-full border-4 border-gray-700 border-t-[#EC1B24]"></div>
          <p className="mt-5 text-xl text-gray-400">{t('ArtistPage.loadingArtist')}</p>
        </div>
      )}

      {/* Error */}
      {error && !loading && (
        <div className="mx-5 my-10 rounded-lg bg-red-500/10 p-8 text-center md:mx-10">
          <p className="text-xl text-red-500">
            {t('ArtistPage.errorOccurred')}: {error}
          </p>
          <button
            onClick={handleBack}
            className="mt-4 rounded-lg bg-[#EC1B24] px-6 py-2 text-white"
          >
            {t('ArtistPage.back')}
          </button>
        </div>
      )}

      {/* Not Found */}
      {notFound && (
        <div className="mt-10 flex flex-col items-center py-20">
          <IconSearchNotFound className="mb-5 size-40 text-gray-700" />
          <p className="text-2xl font-bold text-white">
            {t('ArtistPage.artistNotFound')}
          </p>
        </div>
      )}

      {hasData && !loading && !error && (
        <div className="mt-5 flex-1 px-5 pb-8 pt-[90px] md:px-20">
          <h1 className="mb-5 mt-20 text-center text-[60px] font-bold text-white">
            {t('Playlist.title')}
          </h1>
          {/* Songs Section */}
          {playlist && playlist.playlistShelfs && playlist.playlistShelfs.length > 0 ? (
            <div className="flex flex-col gap-5">
              {playlist.playlistShelfs.map((data, index) => {
                switch (data.type) {
                  case 'song':
                    return (
                      <CWSongCoversSection
                        key={index}
                        shelf={data}
                        interactive={false}
                        isViewAll={true}
                      />
                    );
                  case 'songHorizontalScroll':
                    return (
                      <CWSongCoversSection
                        key={index}
                        shelf={data}
                        interactive={true}
                        isViewAll={true}
                        onClickViewAll={() => {
                          handledClickViewAll(data.id);
                        }}
                        onClickPlaySong={handleSongClick}
                      />
                    );
                }
              })}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <div className="text-lg text-[#B5B5B5]">{t('ArtistPage.noSongsFound')}</div>
            </div>
          )}
        </div>
        )}
      </SongModalProvider>
      <Footer />
    </div>
  );
}
